"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHospital = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M18 6h2a2 2 0 012 2v12c0 1.333-.667 2-2 2h-4c-1.333 0-2-.667-2-2v-5h-4v5c0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2V8a2 2 0 012-2h2V4c0-1.333.667-2 2-2h8c1.333 0 2 .667 2 2v2zm-3 3c.667-.005 1-.338 1-1 0-.662-.334-.995-1-1h-2V5c0-.667-.333-1-1-1s-1 .333-1 1v2H9c-.667.002-1 .335-1 .998S8.333 8.995 9 9h2v2c.006.663.341.997 1.005 1 .663.003.995-.33.995-1V9h2zm-9.5 6h1c.667 0 1-.334 1-1.001V13c.004-.667-.327-1-.996-1H5.5c-.667 0-1 .333-1 1v1c0 .667.333 1 1 1zm0 5h1c.667 0 1-.334 1-1.001V18c.004-.667-.327-1-.996-1H5.5c-.667 0-1 .333-1 1v1c0 .667.333 1 1 1zm12-5h1c.667 0 1-.334 1-1.001V13c.004-.667-.327-1-.996-1H17.5c-.667 0-1 .333-1 1v1c0 .667.333 1 1 1zm0 5h1c.667 0 1-.334 1-1.001V18c.004-.667-.327-1-.996-1H17.5c-.667 0-1 .333-1 1v1c0 .667.333 1 1 1z' }))); };
exports.default = SvgHospital;
//# sourceMappingURL=Hospital.js.map